<lgb-header-gradient [height]="100" [background]="true"></lgb-header-gradient>
<div 
	#searchable="searchable"
	[qSearch]="null"
	[search]="search$()"
	[(results)]="sharings"
	[(searching)]="loading"
	[length]="5"
	class="screen-container"
	[loading]="loading()"
>
	<lgb-back [link]="router.get('collect-home')"></lgb-back>
	<h1 class="my-4">Mes partages</h1>
	<div class="mb-4">
		<lgb-message [(msg)]="message"></lgb-message>
	</div>
	<img src="img/skin/share.svg"/>
	@if(sharings().length){
		<ul class="list bg-base-100 rounded-box shadow-md">
		  <li class="p-4 pb-2 text-xs opacity-60 tracking-wide">
		  	Le destinataire peut consulter le lien tant que le partage est actif.
		  </li>
		  @for(share of sharings(); track share.ident){
			  <li class="list-row">
			    <div>
			      <div class="capitalize">
			      	{{share.type}}
			      </div>
			      <div class="text-xs font-semibold opacity-60">
			      	Créé le : {{share.start | date:'dd/MM/yyyy HH:mm'}}
			      </div>
			    </div>
			    <a [href]="url(share)" target="_blank" class="btn btn-square btn-ghost text-primary">
					<i class="fa-light fa-eyes"></i>
			    </a>
			    <button (click)="disable(share.ident)" class="btn btn-square btn-ghost text-error">
					<i class="fa-light fa-trash-can"></i>
			    </button>
			  </li>
			}
		</ul>
		<div class="pagination mt-4">
			<div class="join">
			  @if(searchable.canPrev()){
		  	  	<button (click)="searchable.prev()" class="join-item btn">«</button>
		  	  }
			  <button class="join-item btn">Page {{searchable.page()+1}}</button>
			  @if(searchable.canNext()){
			  	<button (click)="searchable.next()" class="join-item btn">»</button>
			  }
			</div>
		</div>
	}
	@else{
		<div class="empty-container mb-4">
			<p class="subtitle mb-4">
				Pas encore de lien de partage ici.<br/>
				Créez-en un pour partager vos binders, pages ou cartes.
			</p>
		</div>
	}




</div>
